import { boot } from 'quasar/wrappers'
import { loadQueue, clearQueue } from './loader/loader'
import { bootErrorMessage } from './error/bootErrorMessage'
import { useStore } from '../store'

export default boot(async (/* { app, router, ... } */) => {
  try {
    const store = useStore()
    const route = window.location.href
    const switchTo = route.split('?').find((fragment) => fragment.includes('switch_to='))

    if (typeof switchTo === 'undefined') {
      if (store.user.isLoggedIn) {
        for (const loadItem of loadQueue) {
          await loadItem()
        }
      }
    } else {
      for (const clearItem of clearQueue) {
        await clearItem()
      }
    }
  } catch (error) {
    bootErrorMessage(error, { stage: 'load data' })
  }
})
